import * as React from 'react';

const SvgArrowVector = (props) => (
  <svg
    width={27}
    height={25}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M24.855 1.476c-1.811 3.851-1.62 8.974-.968 12.098m.968-12.098c-2.211 1.955-5.778 6.155-11.457 5.94m11.457-5.94C18.149 13.418 10.814 19.782 1.3 23.502'
      stroke='#E00034'
      strokeWidth={2.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default SvgArrowVector;
